import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  private refreshTokenInProgress: boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private http: HttpClient,
    private appService: AppService
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Prepare request with authentication and CORS support
    req = this.addAuthenticationToken(req);
    req = req.clone({ withCredentials: true });
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && (error.status === 401)) {
          if (req.url.includes("/auth/refresh")) {
            this.appService.logout();
            return
          }
          // 401 errors generalmente se deben a que no está el header de autorización en la llamada
          if (this.refreshTokenInProgress) {
            // si refreshTokenInProgress es true, ese espera hasta que refreshTokenSubject no tenga valor nulo
            // esto indica que el nuevo token está listo y podemos intentar la llamada denuevo
            return this.refreshTokenSubject.pipe(
              filter((result) => result !== null),
              take(1),
              switchMap(() => next.handle(this.addAuthenticationToken(req)))
            );
          } else {
            this.refreshTokenInProgress = true;

            //Seteamos el refreshTokenSubject a null
            this.refreshTokenSubject.next(null);

            return this.refreshAccessToken({ "t": localStorage.getItem("mGJDjUtgSKCdXvBwbjjy"), "r": localStorage.getItem("tVwaiEWPgR6ra0N1gTxSBH0q3EbY0M") }).pipe(
              switchMap((success: boolean) => {
                this.refreshTokenSubject.next(success);
                return next.handle(this.addAuthenticationToken(req));
              }),
              // Cuando la llamada a refreshToken está completa ponemos refreshTokenInProgress en false
              // para la próxima vez, es necesario actualizar el token
              finalize(() => (this.refreshTokenInProgress = false))
            );
          }
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    // Si está llamando a un dominio externo, no agregua el token.
    if (request.url.includes("/auth/login")) {
      return request;
    }

    if (request.url.includes("/auth/refresh")) {
      return (request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem("tVwaiEWPgR6ra0N1gTxSBH0q3EbY0M")}`,
        },
      }));
    }

    if (request.url.includes("public")) {
      return request;
    }

    if (!localStorage.getItem("mGJDjUtgSKCdXvBwbjjy")) {
      this.appService.logout();
      return request;
    }

    if (!localStorage.getItem("tVwaiEWPgR6ra0N1gTxSBH0q3EbY0M")) {
      this.appService.logout();
      return request;
    }

    return (request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem("mGJDjUtgSKCdXvBwbjjy")}`,
      },
    }));
  }

  private refreshAccessToken(request: any): Observable<any> {
    return this.http
      .post(`${environment.apiSimpleLaundry}/auth/refresh`, request)
      .pipe(
        switchMap((res: any) => {
          localStorage.setItem("mGJDjUtgSKCdXvBwbjjy", res.token);
          localStorage.setItem('tVwaiEWPgR6ra0N1gTxSBH0q3EbY0M', res.tokenRefresh);
          this.refreshTokenInProgress = false;
          return of(res);
        }),
        catchError((e) => {
          this.refreshTokenInProgress = false;
          return throwError(() => new Error(e.error.message));
        })
      );
  }
}
